<template>
  <!-- 创建编辑用户信息弹窗 -->
  <el-dialog
    :visible.sync="modelValue"
    width="400px"
    center
    custom-class="manage-create-user"
  >
    <div class="create-name">
      <span>昵称:</span>
      <el-input v-model="nickName" type="text"></el-input>
    </div>
    <div class="show-tip" v-if="isCreated">
      <span>已存在该昵称</span>
    </div>
    <div class="create-roles">
      <span class="title">角色:</span>
      <el-select
        v-model="userRoleUids"
        multiple
        class="create-input__content font-labelheavy"
        popper-class="create-select"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="create-btn">
      <el-button
        class="confirm-btn"
        @click="confirmAddUser({ nickName, userRoleUids })"
        :class="nickName && userRoleUids[0] ? 'is-active' : ''"
        >确定</el-button
      >
      <el-button class="cancel-btn" type="primary" @click="cancelAddUser"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import { ROLE_TYPE } from '../../config/constant';
import { addUser } from '../../api/index';
import { mapGetters } from 'vuex';
export default {
  name: 'ManageCreateUser',
  mixins: [modelMixin],
  props: {
    roleList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isCreated: false,
      options: [
        {
          label: this.roleList[1].roleName,
          value: this.roleList[1].uid
        }
        // {
        //   label: this.roleList[2].roleName,
        //   value: this.roleList[2].uid
        // },
        // {
        //   label: this.roleList[3].roleName,
        //   value: this.roleList[3].uid
        // }
      ],
      userRoleUids: [],
      nickName: '',
      userNumber: ''
    };
  },
  methods: {
    /**
     * 确定创建用户回调
     */
    confirmAddUser({ nickName, userRoleUids }) {
      if (nickName && userRoleUids[0]) {
        addUser({ nickName, userRoleUids })
          .then(res => {
            if (res.data.code == 200) {
              this.modelValue = false;
              this.nickName = '';
              this.userRoleUids = [];
              this.isCreated = false;
              this.$emit('OnUpdateListByAdd');
              this.$prompt('添加成功');
            } else if (res.data.code == 500) {
              // this.$prompt('添加失败');
              this.isCreated = true;
            } else {
              this.$prompt('添加失败');
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    /**
     * 取消创建用户回调
     */
    cancelAddUser() {
      this.nickName = '';
      this.userRoleUids = [];
      this.modelValue = false;
    }
  }
};
</script>

<style lang="scss">
.manage-create-user {
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      padding: 0 40px;
      padding-top: 40px;
      padding-bottom: 20px;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .create-id {
    span {
      margin-right: 40px !important;
    }
  }
  .show-tip {
    position: absolute;
    color: red;
    font-size: 11px;
    margin-left: 70px;
    margin-top: -15px;
    z-index: 200;
  }
  .create-name {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    span {
      margin-right: 15px;
      line-height: 30px;
    }
    .el-input {
      width: 250px;
      height: 30px;
      &__inner {
        width: 250px;
        height: 30px;
        border-radius: 0;
        padding-left: 5px;
        &:focus {
          border-color: $color-border-light;
        }
      }
    }
  }
  .create-roles {
    display: flex;
    justify-content: space-between;
    .title {
      line-height: 30px;
    }
    .create-select {
      .el-select-dropdown {
        &__item {
          height: 20px;
          line-height: 20px;
          font-size: 13px;
          font-family: 'Arial Negreta';
        }
      }
    }
    .create-input__content {
      margin-left: 34px;
      width: 250px;
      .el-input,
      .el-textarea {
        &__inner {
          padding: 0 3px;
          height: 30px;
          font-size: 13px;
          line-height: 30px;
          resize: none;
          border-radius: unset;
          border: 1px solid $color-border-light !important;
          box-shadow: 0;
        }
        &__suffix {
          &-inner {
            display: flex;
            align-items: center;
            height: 100%;
          }
        }
      }
      .el-textarea__inner {
        line-height: 18px;
      }
      .el-select {
        &__caret {
          color: #000 !important;
          font-weight: bold;
          font-size: 12px !important;
          line-height: 1;
        }
      }
    }
  }
  .create-btn {
    display: flex;
    justify-content: center;
    margin-top: 35px;
    .el-button {
      border: 0;
    }
    .confirm-btn {
      margin-right: 20px;
      background-color: $color-disabled;
      font-size: 13px;
      color: #fff;
    }
    .is-active {
      background-color: $color-primary;
    }
  }
}
</style>
